import { Component, OnInit } from '@angular/core';
import { SapiService } from '../../../services/sapi.service';
import { Embargo } from 'app/components/shared/bb-embargo/bb-embargo.component';
import { Params, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
	selector: 'upload-transcode',
	templateUrl: './upload-transcode.component.html',
	styleUrls: ['./upload-transcode.component.scss']
})


export class UploadTranscodeComponent implements OnInit {
	activeTab: string;
	today: Date = new Date();
	currentTime: string;
	autoName = false;
	autoPublish = false;
	embargo: Embargo;

	constructor(
		protected route: ActivatedRoute,
		protected sapiService: SapiService,
		protected localStorageService: LocalStorageService
	) {
	}

	ngOnInit() {
		this.getToday();

		this.route.params.subscribe((params: Params) => {
			this.activeTab = params.tab;
		});

		this.getSettings();
	}

	getToday(): Date {
		this.getCurrentTime();
		return this.today;
	}

	getCurrentTime() {
		const today = new Date();
		const h = (today.getHours() < 10 ? '0' : '') + today.getHours();
		const m = (today.getMinutes() < 10 ? '0' : '') + today.getMinutes();
		this.currentTime = h + ':' + m;
	}

	getSettings() {
		if (this.localStorageService.get('ovp-autoName')) {
			this.autoName = this.localStorageService.get('ovp-autoName');
		}
		if (this.localStorageService.get('ovp-autoPublish')) {
			this.autoPublish = this.localStorageService.get('ovp-autoPublish');
		}
	}
}
